export const queryKeys = {
  base: () => ['settings'] as const,
  public: () => [...queryKeys.base(), 'public'] as const,
  additionalFunctionality: () =>
    [...queryKeys.base(), 'additional_functionality'] as const,
  experimental: () => [...queryKeys.base(), 'experimental'] as const,
  debug: () => [...queryKeys.base(), 'debug'] as const,
  allowlist: () => ['allowlist'] as const,
};
